import { Box, Checkbox, CircularProgress, colors, FormControlLabel, TextField, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { AuthContext } from '../utils/AuthContext';
import { fetchNotes, reuploadRates, updateNotes, updateRates, uploadNewRates } from '../services/InsurerRateService';

export default function NotesFormDialog({ open, setOpen, selectedTitle,
  setIsFileUploading, insurerRate }) {
  const { auth, setAuth } = useContext(AuthContext);

  const [notes, setNotes] = useState('');

  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (!insurerRate) {
      return;
    }

    setNotes('');

    handleFetchNotes();
  }, [insurerRate]);

  function handleFetchNotes() {
    
    setLoading(true);


    fetchNotes({ token: auth.token, insurerRateId: insurerRate.id }).then((res) => {
      if (res.data && res.data.notes) {
        setNotes(res.data.notes);
      } else {
        setNotes('');
      }

      setLoading(false);
    });
  }

  function handleUpdateNotes() {
    const formData = {
      notes
    };

    setOpen(false);
    setIsFileUploading(true);

    const toastId = toast.loading("Updating Notes...");

    updateNotes({ body: formData, token: auth.token, insurerRateId: insurerRate.id }).then(() => {
      toast.update(toastId, {
        type: 'success',
        render: selectedTitle + ' Notes Updated',
        autoClose: 2500,
        closeButton: true,
        hideProgressBar: true,
        isLoading: false
      });

      setIsFileUploading(false);
    })
      .catch(err => {
        setIsFileUploading(false);
      });
  }


  function handleSubmit() {
    handleUpdateNotes();
  }

  const handleClose = () => {
    setOpen(false);
  };

  function getTitle() {
    return 'Edit Notes';
  }

  function getPositiveButtonLabel() {
    return 'Submit';
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      maxWidth="lg"
    >
      <DialogTitle id="dialog-title">
        {getTitle()}
      </DialogTitle>
      <DialogContent sx={{ minWidth: 700 }}>
        <Box minWidth={500}>
          {
            isLoading ? <Box sx={{ display: 'flex', justifyContent: 'center' }}><CircularProgress /></Box> :

              <TextField
                autoFocus
                margin="dense"
                id="notes"
                label="Notes"
                type="text"
                fullWidth
                variant="outlined"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                multiline
                rows={10}
              />
          }

        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button autoFocus onClick={handleSubmit}>
          {getPositiveButtonLabel()}
        </Button>
      </DialogActions>
    </Dialog>
  );
}